import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../app/applicationSlice";
import { RootState, RootThunk } from "../../app/store";
import {
  getCancel as apiGetCancel,
  getCountList as apiGetCountList,
  getHomeList as apiGetHomeList,
  getMessageList as apiGetMessageList,
  getState as apiGetStates,
  IdParams,
} from "../../services/home";

const initialState = {
  homeDate: [],
  countData: {},
  messageData: [],
  stateData: [],
  cancelData: [],
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setDepartments: (state, action) => {
      state.homeDate = action.payload;
    },
    setCountList: (state, action) => {
      state.countData = action.payload;
    },
    setMessageList: (state, action) => {
      state.messageData = action.payload;
    },
    setStates: (state, action) => {
      state.stateData = action.payload;
    },
    setCancels: (state, action) => {
      state.cancelData = action.payload;
    },
  },
});

const {
  setDepartments,
  setCountList,
  setMessageList,
  setStates,
  setCancels,
} = homeSlice.actions;

export function getHomeList(id?: number): RootThunk {
  return api(apiGetHomeList(id), (data: any, dispatch) => {
    dispatch(setDepartments([data.unRegVO, data.inReg]));
  });
}
export function getCountList(id?: number): RootThunk {
  return api(apiGetCountList(id), (data: any, dispatch) => {
    const count = data;
    dispatch(setCountList(count));
  });
}
export function getMessageList(id?: number): RootThunk {
  return api(apiGetMessageList(id), (data: any, dispatch) => {
    dispatch(setMessageList(_.chain(data).take(4).value()));
  });
}

export function getState(body: IdParams): RootThunk {
  return (dispatch, getState, args) => {
    const state = getState().home.messageData;
    api(apiGetStates(body), (data: any, dispatch) => {
      dispatch(setStates(state));
      dispatch(getMessageList());
    })(dispatch, getState, args);
  };
}
export function getCancel(id: number): RootThunk {
  return (dispatch, getState, args) => {
    const cancel = getState().home.cancelData;
    api(apiGetCancel(id), (data: any, dispatch) => {
      dispatch(setCancels(cancel));
      dispatch(getCountList());
      dispatch(getHomeList());
    })(dispatch, getState, args);
  };
}

export const selectHomedata = (state: RootState) => state.home.homeDate;

export const selectCountdata = (state: RootState) => state.home.countData;

export const selectMessagedata = (state: RootState) => state.home.messageData;

export const selectStatedata = (state: RootState) => state.home.stateData;

export const selectCanceldata = (state: RootState) => state.home.cancelData;

export default homeSlice.reducer;
